module.exports = __webpack_public_path__ + "static/media/cargill-logo.a71efee3.svg";